/* app/js/src/components/common/calendar-icon/calendar-icon.component.scss */
/*# sourceMappingURL=calendar-icon.component.css.map */
